(function() {
  'use strict';

  // ─── moo-price-sync ──────────────────────────────────────────────────────
  // Sur les pages produit cuisine UNIQUEMENT (body.is-cuisine présent),
  // force tous les prix affichés à utiliser le calcul dynamique moood
  // (somme des meubles via ce_produit_contient_*) au lieu du prix Shopify
  // natif de la variante.
  //
  // GARDE STRICTE : le script ne fait absolument RIEN si body.is-cuisine
  // n'est pas présent. Ceinture + bretelles pour ne jamais affecter
  // les autres produits (robinets, plinthes, façades, etc.).
  // ─────────────────────────────────────────────────────────────────────────

  // ─── GARDE STRICTE — bail early si pas une cuisine ─────────────────────
  function isCuisinePage() {
    return document.body && document.body.classList.contains('is-cuisine');
  }

  // Si on n'est pas sur une page cuisine, on quitte immédiatement.
  // Ça couvre TOUTES les pages : home, collections, robinets, plinthes,
  // façades, crédences, niches, étagères, caissons, accessoires, etc.
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function() {
      if (!isCuisinePage()) return;
      bootCuisinesPriceSync();
    });
  } else {
    if (!isCuisinePage()) return;
    bootCuisinesPriceSync();
  }

  // ─── Tout le reste de la logique est dans cette fonction, et n'est ──────
  // ─── exécutée QUE si on est sur une page cuisine ────────────────────────
  function bootCuisinesPriceSync() {

    // Multiplicateur cuisinistes : 2.3, arrondi dizaine supérieure
    var CUISINISTE_MULT = 2.3;

    // ─── helpers parsing/formatage ────────────────────────────────────────
    function parseEur(str) {
      if (!str) return null;
      var clean = String(str).replace(/[€\s\u00a0]/g, '');
      if (clean.indexOf(',') !== -1) {
        clean = clean.replace(/\./g, '').replace(',', '.');
      }
      var n = parseFloat(clean);
      return isFinite(n) ? n : null;
    }

    function fmtEur(n) {
      if (!isFinite(n)) return '';
      return n.toLocaleString('fr-FR', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
      }) + ' €';
    }

    function fmtEurNoDec(n) {
      if (!isFinite(n)) return '';
      return Math.round(n).toLocaleString('fr-FR') + ' €';
    }

    function ceilToTen(n) {
      return Math.ceil(n / 10) * 10;
    }

    // ─── détection du prix moood depuis le DOM ────────────────────────────
    // STRICT : ne match QUE les éléments qui contiennent "Prix approximatif moood"
    function getMoodPrice() {
      // Cherche les éléments qui contiennent "approximatif moood" dans leur texte direct
      var candidates = document.querySelectorAll('.shopify-block.block-product__price.my-custom, .price, .product__price');
      for (var i = 0; i < candidates.length; i++) {
        var txt = candidates[i].textContent || '';
        // Garde UNIQUEMENT les éléments qui mentionnent explicitement "approximatif moood"
        if (txt.indexOf('approximatif moood') === -1) continue;
        // Extraire le PREMIER nombre suivi de € (donc le prix moood, pas la valeur cuisinistes)
        var m = txt.match(/approximatif moood\s*:\s*([0-9][0-9\s.\u00a0]*,[0-9]{2})\s*€/);
        if (m) {
          var n = parseEur(m[1]);
          if (n && n > 0) return n;
        }
      }
      return null;
    }

    // ─── application des prix dans le DOM ────────────────────────────────
    function applyPrices(moodPrice) {
      if (!moodPrice || moodPrice <= 0) return;

      var cuisiniste = ceilToTen(moodPrice * CUISINISTE_MULT);
      var economy = Math.round((1 - moodPrice / cuisiniste) * 100);

      // 1. Badge en haut de l'image : "dès XXX €"
      document.querySelectorAll('.mprod-v2-gallery__badge').forEach(function(el) {
        el.textContent = 'dès ' + fmtEur(moodPrice);
      });

      // 2. Bloc "Prix habituel" Shopify natif (.price-regular > .price)
      // (déjà masqué par CSS sur les cuisines mais on met à jour quand même
      // pour éviter les flashes au load)
      document.querySelectorAll('.price-regular .price, .card-product-price .price').forEach(function(el) {
        var txt = (el.textContent || '');
        if (txt.indexOf('À partir de') !== -1) return;
        el.textContent = fmtEur(moodPrice);
      });

      // 3. Comparatif cuisinistes
      document.querySelectorAll('.mprod-v2-price-compare').forEach(function(el) {
        el.textContent = fmtEurNoDec(cuisiniste) + ' chez les autres';
      });

      // 4. Pourcentage d'économie
      document.querySelectorAll('.mprod-v2-price-save').forEach(function(el) {
        el.textContent = '-' + economy + '% vs cuisinistes';
      });

      // 5. "Valeur estimée chez les cuisinistes XXX €"
      document.querySelectorAll('.shopify-block.block-product__price.my-custom').forEach(function(container) {
        var txt = container.textContent || '';
        if (txt.indexOf('Valeur estimée chez les cuisinistes') === -1) return;
        var strongs = container.querySelectorAll('strong');
        if (strongs.length >= 2) {
          strongs[1].textContent = fmtEur(cuisiniste);
        }
      });
    }

    // ─── orchestration ───────────────────────────────────────────────────
    var lastApplied = null;
    function tick() {
      // Re-check garde au cas où la classe is-cuisine serait retirée dynamiquement
      if (!isCuisinePage()) return;
      var moodPrice = getMoodPrice();
      if (!moodPrice) return;
      if (moodPrice === lastApplied) return;
      lastApplied = moodPrice;
      applyPrices(moodPrice);
    }

    // Premier tick rapide
    tick();

    // Tick répété pendant 8s pour rattraper les calculs async des autres scripts
    var n = 0;
    var iv = setInterval(function() {
      n++;
      tick();
      if (n > 40) clearInterval(iv);
    }, 200);

    // Observer les changements de DOM (changement de couleur déclenche un re-render)
    if (window.MutationObserver) {
      var mo = new MutationObserver(function() {
        var newPrice = getMoodPrice();
        if (newPrice && newPrice !== lastApplied) {
          lastApplied = newPrice;
          applyPrices(newPrice);
        }
      });
      var roots = document.querySelectorAll('.shopify-block.block-product__price.my-custom, .price, .product__price');
      roots.forEach(function(r) {
        mo.observe(r, { childList: true, subtree: true, characterData: true });
      });
    }

    // Listeners pour les changements de variant
    document.addEventListener('moo:color-change', function() {
      setTimeout(tick, 50);
      setTimeout(tick, 300);
    });
    document.addEventListener('moo:poignee-change', function() {
      setTimeout(tick, 50);
      setTimeout(tick, 300);
    });
    document.addEventListener('variant:change', function() {
      setTimeout(tick, 50);
      setTimeout(tick, 300);
    });
  }
})();